import React from "react"
import Logo from "../components/icons/animated-logo"
import Layout from "../components/layout"

export default () => (
  <Layout title="64 Ways of Being" className="home">
    <Logo fill="#edeae3" />
  </Layout>
)
